export default "__VITE_ASSET__xrI3EPob__"